// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationLogOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.199 3.002a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5h-4.32c-.53 0-.96.448-.96 1v12c0 .553.43 1 .96 1h4.32a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5h-4.32c-1.59 0-2.88-1.343-2.88-3v-12c0-1.657 1.29-3 2.88-3zm6.095 13.354a.467.467 0 0 1-.679 0l-.679-.707a.515.515 0 0 1 0-.708l1.862-1.939H8.076a.49.49 0 0 1-.48-.5v-1c0-.276.215-.5.48-.5h8.722l-1.862-1.94a.515.515 0 0 1 0-.706l.68-.707a.467.467 0 0 1 .678 0l3.84 4a.515.515 0 0 1 0 .707z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationLogOut;
